import { useHistory } from "react-router-dom";
import styles from './index.module.css';
import { Typography, Box } from "@material-ui/core";
import { toCurrency } from '../../../utils';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';

export interface ICreditUtilisation {
	creditLimit: number;
	available: number;
	utilized: number;
}

const CreditUtilisation = ({ data }: { data: ICreditUtilisation }) => {
	const history = useHistory();
	const userState = useSelector((state: IAppState) => state.authReducer.user)
	const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
	const { locale, currency } = consumerState.consumerWebsite.organisation
	const { t } = useTranslation()

	const utilizationPercentage = data.creditLimit > 0 ? ((data.utilized / 100) / data.creditLimit) * 100 : 0;

	return (
		<Box className={styles.enhancedCard}>
			<Box className={styles.cardContentEnhanced}>
				<Box display="flex" alignItems="center" justifyContent="space-between">
					<Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
						{t("root:creditUtilisation")}
					</Typography>
					<Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #06b6d4, #0891b2)" }}>
						💳
					</Box>
				</Box>

				<Box>
					<Box textAlign="center" style={{ margin: "15px 0" }}>
						<Typography variant="body2" style={{ color: "#64748b", fontSize: "14px", marginBottom: "4px" }}>
							{t("root:creditLimit")}
						</Typography>
						<Typography
							variant="h3"
							style={{
								fontWeight: 700,
								color: "#1e293b",
								fontSize: "28px",
								lineHeight: "1.2",
								cursor: "pointer"
							}}
							onClick={() => history.push("/account/credit-notes")}
						>
							{toCurrency(data.creditLimit * 100, currency, locale)}
						</Typography>
					</Box>

					<Box display="flex" alignItems="center" style={{ margin: "20px 0" }}>
						<Box style={{ position: "relative", width: "80px", height: "80px", marginRight: "20px" }}>
							<svg width="80" height="80" viewBox="0 0 80 80">
								<circle cx="40" cy="40" r="35" fill="none" stroke="#e2e8f0" strokeWidth="10" />
								<circle
									cx="40"
									cy="40"
									r="35"
									fill="none"
									stroke="url(#creditGradient)"
									strokeWidth="10"
									strokeDasharray={`${(utilizationPercentage / 100) * 220} 220`}
									strokeDashoffset="0"
									transform="rotate(-90 40 40)"
								/>
								<defs>
									<linearGradient id="creditGradient" x1="0%" y1="0%" x2="100%" y2="0%">
										<stop offset="0%" stopColor="#06b6d4" />
										<stop offset="100%" stopColor="#0891b2" />
									</linearGradient>
								</defs>
							</svg>
						</Box>

						<Box>
							<Box style={{ marginBottom: "8px" }}>
								<Typography variant="body2" style={{ color: "#64748b", fontSize: "12px" }}>
									{t("root:utilized")} : {toCurrency(data.utilized, currency, locale)}
								</Typography>
							</Box>
							<Box>
								<Typography variant="body2" style={{ color: "#64748b", fontSize: "12px" }}>
									{t("root:available")} : {toCurrency(data.available, currency, locale)}
								</Typography>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default CreditUtilisation